export default __webpack_public_path__ + "static/media/moreNavs.2fcef6c5.svg";